export default __webpack_public_path__ + "static/media/icon_cancelled.5f073545.svg";